module.exports = __webpack_public_path__ + "static/img/workerradar.ede5f6e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workerradar.jpeg
// module id = 3XvZ
// module chunks = 73